import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err=>err);
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: "/login",
      name: "Login",
      component: () => import("@/components/Login"),
      meta: { requireAuth: false }
    },
    {
      path: "/register",
      name: "Register",
      component: () => import("@/components/Register"),
      meta: { requireAuth: false }
    },
    {
      path: "/recover",
      name: "Recover",
      component: () => import("@/components/Recover"),
      meta: { requireAuth: false }
    },
    {
      path: "/outpatient",
      name: "Outpatient",
      component: () => import("@/components/outpatient/visit/Outpatient"),
      meta: { requireAuth: true }
    },
    {
      path: "/pres",
      name: "Prescription",
      component: () => import("@/components/prescription/Prescription"),
      meta: { requireAuth: true }
    },
    {
      path: "/telemed",
      name: "ExpertTelemed",
      component: () => import("@/components/telemed/expert/ExpertTelemed"),
      meta: { requireAuth: true }
    },
    {
      path: "/telemed/room",
      name: "ExpertTelemedRoom",
      component: () => import("@/components/telemed/expert/ExpertTelemedRoom"),
      meta: { requireAuth: true }
    },
    {
      path: "/",
      redirect: "/layout"
    },
    {
      path: "/layout",
      name: "Gpws",
      component: () => import("@/components/Gpws"),
      meta: { requireAuth: true },
      children: [
        {
          path: "/layout/outpatient/register",
          name: "OutpatientRegister",
          component: () => import("@/components/outpatient/register/Register"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/registration",
          name: "Registration",
          component: () => import("@/components/outpatient/register/Registration"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient",
          name: "OutpatientVisit",
          component: () => import("@/components/outpatient/outpatient/Outpatient"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/visit",
          name: "Visit",
          component: () => import("@/components/outpatient/outpatient/Visit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/examine",
          name: "ExamineOutpatient",
          component: () => import("@/components/outpatient/examine/ExamineOutpatient"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/charge",
          name: "OutpatientCharge",
          component: () => import("@/components/outpatient/charge/OutpatientCharge"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/charged",
          name: "OutpatientCharged",
          component: () => import("@/components/outpatient/charge/OutpatientCharged"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/refund",
          name: "OutpatientRefund",
          component: () => import("@/components/outpatient/charge/OutpatientRefund"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/arrearage",
          name: "OutpatientArrearage",
          component: () => import("@/components/outpatient/charge/OutpatientArrearage"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/give/drug",
          name: "OutpatientGiveDrug",
          component: () => import("@/components/outpatient/give/OutpatientGiveDrug"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/refund/drug",
          name: "OutpatientRefundDrug",
          component: () => import("@/components/outpatient/give/OutpatientRefundDrug"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/telemeds",
          name: "TelemedOutpatient",
          component: () => import("@/components/telemed/doctor/TelemedOutpatient"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/outpatient/doctor/room",
          name: "DoctorRoom",
          component: () => import("@/components/telemed/doctor/DoctorRoom"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/roam/outpatient",
          name: "AbnormalOutpatient",
          component: () => import("@/components/roam/AbnormalOutpatient"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/roam/balance",
          name: "BalanceOutpatient",
          component: () => import("@/components/roam/BalanceOutpatient"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/roam/recipe/accept",
          name: "RoamAcceptRecipe",
          component: () => import("@/components/roam/recipe/AcceptRecipe"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/roam/recipe/dispose",
          name: "RoamDisposeRecipe",
          component: () => import("@/components/roam/recipe/DisposeRecipe"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/roam/recipe/deliver",
          name: "RoamDeliveredRecipe",
          component: () => import("@/components/roam/recipe/DeliveredRecipe"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/roam/recipe/finish",
          name: "RoamFinishedRecipe",
          component: () => import("@/components/roam/recipe/FinishedRecipe"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/account",
          name: "ClinicAccountSplit",
          component: () => import("@/components/system/split/ClinicAccountSplit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/examine",
          name: "RecipeExamine",
          component: () => import("@/components/system/examine/RecipeExamine"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/account/withdraw",
          name: "ClinicWithdraw",
          component: () => import("@/components/system/split/ClinicWithdraw"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/role",
          name: "Role",
          component: () => import("@/components/system/role/Role"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/organ",
          name: "Organ",
          component: () => import("@/components/system/organ/Organ"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/organ/edit",
          name: "OrganEdit",
          component: () => import("@/components/system/organ/OrganEdit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/department",
          name: "Department",
          component: () => import("@/components/system/department/Department"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/doctor",
          name: "Doctor",
          component: () => import("@/components/system/doctor/Doctor"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/doctor/create",
          name: "DoctorCreate",
          component: () => import("@/components/system/doctor/DoctorCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/doctor/edit",
          name: "DoctorEdit",
          component: () => import("@/components/system/doctor/DoctorEdit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/schedule",
          name: "Schedule",
          component: () => import("@/components/system/schedule/Schedule"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/template",
          name: "TemplateSetting",
          component: () => import("@/components/system/template/TemplateSetting"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/dispose",
          name: "Dispose",
          component: () => import("@/components/system/dispose/Dispose"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/dispose/create",
          name: "DisposeCreate",
          component: () => import("@/components/system/dispose/DisposeCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/dispose/edit",
          name: "DisposeEdit",
          component: () => import("@/components/system/dispose/DisposeEdit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/system/user",
          name: "user",
          component: () => import("@/components/system/user/User"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/account",
          name: "MineAccountSplit",
          component: () => import("@/components/mine/split/MineAccountSplit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/fee/setting",
          name: "MineFeeSetting",
          component: () => import("@/components/mine/setting/BasicFeeConfig"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/medical/template",
          name: "MedicalTemplate",
          component: () => import("@/components/mine/template/Medical"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/register",
          name: "MineRegistration",
          component: () => import("@/components/mine/register/Registration"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/outpatient",
          name: "MineOutpatient",
          component: () => import("@/components/mine/outpatient/Outpatient"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/telemeds",
          name: "MineTelemedOutpatient",
          component: () => import("@/components/mine/telemed/TelemedOutpatient"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/examine",
          name: "MineExamine",
          component: () => import("@/components/mine/examine/MineExamine"),
          meta: { requireAuth: true }
        },


        {
          path: "/layout/mine/member",
          name: "MineMember",
          component: () => import("@/components/mine/member/MineMember"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/favorite",
          name: "MineFavorite",
          component: () => import("@/components/mine/favorite/Favorite"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/pres",
          name: "MineOwnPres",
          component: () => import("@/components/mine/pres/OwnPres"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/pres/create",
          name: "MineOwnPresCreate",
          component: () => import("@/components/mine/pres/OwnPresCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/pres/edit",
          name: "MineOwnPresEdit",
          component: () => import("@/components/mine/pres/OwnPresEdit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/history",
          name: "OutpatientHistory",
          component: () => import("@/components/mine/history/OutpatientHistory"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/mine/history/import",
          name: "OutpatientHistoryImport",
          component: () => import("@/components/mine/history/OutpatientHistoryImport"),
          meta: { requireAuth: true }
        },
        {
          path: '/layout/system/config',
          name: 'Config',
          component: () => import("@/components/system/config/Config"),
          meta: {requireAuth: true},
          children:[
            {
              path: '/layout/system/config/params',
              name: 'ParamConfig',
              component: () => import("@/components/system/config/param/ParamConfig"),
              meta: {requireAuth: true}
            },
            {
              path: '/layout/system/config/account',
              name: 'AccountConfig',
              component: () => import("@/components/system/config/account/AccountConfig"),
              meta: {requireAuth: true}
            },
            {
              path: '/layout/system/config/basic',
              name: 'BasicConfig',
              component: () => import("@/components/system/config/basic/BasicConfig"),
              meta: {requireAuth: true}
            }
          ]
        },
        {
          path: '/layout/system/fee',
          name: 'Fee',
          component: () => import("@/components/system/fee/FeeConfig"),
          meta: {requireAuth: true},
          children:[
            {
              path: '/layout/system/fee/basic',
              name: 'BasicFeeConfig',
              component: () => import("@/components/system/fee/basic/BasicFeeConfig"),
              meta: {requireAuth: true}
            },
            {
              path: '/layout/system/fee/express',
              name: 'ExpressSetting',
              component: () => import("@/components/system/fee/express/ExpressSetting"),
              meta: {requireAuth: true}
            },
            {
              path: '/layout/system/fee/usage',
              name: 'UsageConfig',
              component: () => import("@/components/system/fee/usage/UsageConfig"),
              meta: {requireAuth: true}
            }
          ]
        },
        {
          path: "/layout/pharmacy/drug",
          name: "Drug",
          component: () => import("@/components/pharmacy/drug/Drug"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/drug/create",
          name: "DrugCreate",
          component: () => import("@/components/pharmacy/drug/DrugCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/drug/edit",
          name: "DrugEdit",
          component: () => import("@/components/pharmacy/drug/DrugEdit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/drug/hqedit",
          name: "DrugHqEdit",
          component: () => import("@/components/pharmacy/drug/DrugHqEdit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/drug/price/index",
          name: "DrugPrice",
          component: () => import("@/components/pharmacy/drug/DrugPrice"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/drug/price/plans",
          name: "DrugPricePlans",
          component: () => import("@/components/pharmacy/drug/DrugPricePlans"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/stockin",
          name: "StockIn",
          component: () => import("@/components/pharmacy/stockin/StockIn"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/stockin/create",
          name: "StockInCreate",
          component: () => import("@/components/pharmacy/stockin/StockInCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/stockin/detail",
          name: "StockInDetail",
          component: () => import("@/components/pharmacy/stockin/StockInDetail"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchasein",
          name: "PurchaseIn",
          component: () => import("@/components/pharmacy/purchasein/PurchaseIn"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchasein/batchcreate",
          name: "PurchaseInBatchCreate",
          component: () => import("@/components/pharmacy/purchasein/PurchaseInBatchCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchasein/create",
          name: "PurchaseInCreate",
          component: () => import("@/components/pharmacy/purchasein/PurchaseInCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchasein/detail",
          name: "PurchaseInDetail",
          component: () => import("@/components/pharmacy/purchasein/PurchaseInDetail"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchasein/audit",
          name: "PurchaseInAudit",
          component: () => import("@/components/pharmacy/purchasein/PurchaseInAudit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchaseout",
          name: "PurchaseOut",
          component: () => import("@/components/pharmacy/purchaseout/PurchaseOut"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchaseout/stockinout",
          name: "StockInOut",
          component: () => import("@/components/pharmacy/purchaseout/StockInOut"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/purchaseout/audit",
          name: "PurchaseOutAudit",
          component: () => import("@/components/pharmacy/purchaseout/PurchaseOutAudit"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/stockout/create",
          name: "StockOutCreate",
          component: () => import("@/components/pharmacy/stockout/StockOutCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/stockout/detail",
          name: "StockOutDetail",
          component: () => import("@/components/pharmacy/stockout/StockOutDetail"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/breakage",
          name: "Breakage",
          component: () => import("@/components/pharmacy/breakage/Breakage"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/breakage/create",
          name: "BreakageCreate",
          component: () => import("@/components/pharmacy/breakage/BreakageCreate"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/stockout",
          name: "StockOut",
          component: () => import("@/components/pharmacy/stockout/StockOut"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/inventory",
          name: "Inventory",
          component: () => import("@/components/pharmacy/inventory/Inventory"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/inventory/in",
          name: "InventoryIn",
          component: () => import("@/components/pharmacy/inventory/InventoryIn"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/inventory/out",
          name: "InventoryOut",
          component: () => import("@/components/pharmacy/inventory/InventoryOut"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/stock/change/log",
          name: "StockChangeLog",
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/warn",
          name: "StockWarn",
          component: () => import("@/components/pharmacy/warn/StockWarn"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/datewarn",
          name: "StockDateWarn",
          component: () => import("@/components/pharmacy/warn/StockDateWarn"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/simple",
          name: "Simple",
          component: () => import("@/components/pharmacy/simple/Simple"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/supplier",
          name: "Supplier",
          component: () => import("@/components/pharmacy/supplier/Supplier"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/roam",
          name: "RoamRecipe",
          component: () => import("@/components/pharmacy/roam/RoamRecipe"),
          meta: { requireAuth: true }
        },
        {
          path: "/layout/pharmacy/organ/roam",
          name: "OrganRoam",
          component: () => import("@/components/pharmacy/roam/OrganRoam"),
          meta: { requireAuth: true }
        }
      ]
    }
  ]
})
